export const PERSONAL_DETAILS = `פרטים אישיים`